import React from 'react'
import Widget from 'widgets/Widget'
import Section from 'layouts/page/Section'

export default class AdminTopNavigation extends Widget {
  get menuItems () {
    return (
      <ul className='top-navigation__items'>
        <li className='top-navigation__item' />
        <li className='top-navigation__item' />
        <li className='top-navigation__item' />
      </ul>
    )
  }

  renderWidget () {
    return (
      <Section>
        <div className='top-navigation ghost' />
        <div className='top-navigation'>
          <div className='top-navigation__item-wrap'>
            {this.menuItems}
          </div>
        </div>
      </Section>
    )
  }
}
